import React, { useState } from "react";
import { Offcanvas, Button, ListGroup, Form, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";

const AdminPanel = () => {
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const linkStyle = {
    color: "#d0021b", // Color rojo del logo
    textDecoration: "none",
    fontWeight: "bold",
  };

  const hoverStyle = {
    color: "#a00115", // Color más oscuro para hover
  };

  // Lista de enlaces ordenada alfabéticamente
  const adminLinks = [
    { to: "/admin/beneficios", text: "Gestión de Beneficios" },
    { to: "/admin/carga-masiva-usuarios", text: "Carga Masiva de Usuarios" },
    { to: "/admin/convenios", text: "Gestión de Convenios" },
    { to: "/admin/correos", text: "Correo Masivo" },
    { to: "/admin/dashboard", text: "Dashboard General" },
    { to: "/admin/directiva", text: "Administrar Directiva del Sindicato" },
    { to: "/admin/documentos", text: "Gestión de Documentos" },
    { to: "/admin/encuestas", text: "Gestión de Encuestas" },
    { to: "/admin/encuestas/resultados", text: "Ver Resultados de Encuestas" },
    { to: "/admin/exportar-usuarios", text: "Exportar Usuarios" },
    { to: "/admin/faq", text: "Gestión de Preguntas Frecuentes (FAQ)" }, // NUEVO
    { to: "/admin/noticias", text: "Gestión de Noticias" },
    { to: "/admin/usuarios", text: "Gestión de Usuarios" },
  ];

  // Ordenar enlaces alfabéticamente (copia, para no mutar el array original)
  const sortedLinks = [...adminLinks].sort((a, b) => a.text.localeCompare(b.text));

  // Filtrar enlaces basados en el término de búsqueda
  const filteredLinks = sortedLinks.filter((link) =>
    link.text.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {/* Botón del Panel de Administración */}
      <Button
        onClick={handleShow}
        style={{
          backgroundColor: "#d0021b",
          border: "none",
          fontWeight: "bold",
          textTransform: "uppercase",
          padding: "8px 16px",
        }}
      >
        Panel de Administración
      </Button>

      {/* Offcanvas para el Panel */}
      <Offcanvas show={show} onHide={handleClose} placement="end" style={{ width: "300px" }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{
              color: "#d0021b",
              fontWeight: "bold",
              textTransform: "uppercase",
              fontSize: "1.5rem",
            }}
          >
            Panel de Administración
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* Campo de búsqueda con botón para limpiar */}
          <InputGroup className="mb-3">
            <Form.Control
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Buscar en el panel de administración"
              style={{ borderColor: "#d0021b" }}
            />
            {searchTerm && (
              <Button
                variant="outline-danger"
                onClick={() => setSearchTerm("")}
                aria-label="Borrar búsqueda"
                title="Borrar búsqueda"
              >
                <i className="bi bi-x-lg" aria-hidden="true"></i>
              </Button>
            )}
          </InputGroup>

          {/* Lista de enlaces */}
          <ListGroup variant="flush">
            {filteredLinks.length === 0 ? (
              <ListGroup.Item className="text-muted small px-3 py-2">
                Sin resultados para «{searchTerm}»
              </ListGroup.Item>
            ) : (
              filteredLinks.map((link, index) => (
                <ListGroup.Item key={index} className="px-3 py-2" onClick={handleClose}>
                  <Link
                    to={link.to}
                    style={linkStyle}
                    onMouseEnter={(e) => (e.target.style.color = hoverStyle.color)}
                    onMouseLeave={(e) => (e.target.style.color = linkStyle.color)}
                  >
                    {link.text}
                  </Link>
                </ListGroup.Item>
              ))
            )}
          </ListGroup>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AdminPanel;